import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import Autocomplete from "@mui/material/Autocomplete";
import countries from "../../../utils/CountryCodeData";
import {
  addUserMasterList,
  setIsOpenModelAddUserMaster,
} from "../../../redux/actions/mastersAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

export const passwordGenerator = () => {
  return stringGen(4) + "@" + numberGen(4);
};
export const stringGen = (len) => {
  var text = "";
  var charset = "abcdefghijklmnopqrstuvwxyz";
  for (var i = 0; i < len; i++)
    text += charset.charAt(Math.floor(Math.random() * charset.length));
  return text;
};
export const numberGen = (len) => {
  var text = "";
  var charset = "0123456789";
  for (var i = 0; i < len; i++)
    text += charset.charAt(Math.floor(Math.random() * charset.length));
  return text;
};

const AddVesselAdminMasterModel = (Props) => {
  const dispatch = useDispatch();
  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );
  const VessalAdminID = localStorage.getItem("VessalAdminID");
  const defaultCountry = countries.find((country) => country.code === "AE");
  const CompanyID = localStorage.getItem("companyID");
  const AddVesselAdminModel = useSelector(
    (state) => state?.masters?.models?.AddUserMasterModel
  );
  const [CountryCodeValue, setCountryCodeValue] = useState(
    defaultCountry?.phone
  );
  const [vesselName, setvesselName] = useState("");

  const handleChangeCountryCodeValue = (newValue) => {
    setCountryCodeValue(newValue?.phone);
  };
  const handleChangevesselName = (event) => {
    setvesselName(event.target.value);
  };

  const [VesselAdminData, setVesselAdminData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    CompanyPhoneNo: "",
  });

  const handleChangeVesselAdminData = (e) => {
    const { name, value } = e.target;
    setVesselAdminData({ ...VesselAdminData, [name]: value });
  };

  const vesselMasterData = useSelector(
    (state) => state?.masters?.vesselMasterData
  );

  const handleSaveVesselAdmin = async (event) => {
    event.preventDefault();
    if (
      VesselAdminData?.FirstName !== "" &&
      VesselAdminData?.LastName !== "" &&
      VesselAdminData?.Email !== "" &&
      CountryCodeValue !== undefined &&
      VesselAdminData?.CompanyPhoneNo !== "" &&
      vesselName !== ""
    ) {
      const emailPattern =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (emailPattern.test(VesselAdminData?.Email)) {
        dispatch(
          addUserMasterList({
            first_name: VesselAdminData?.FirstName,
            last_name: VesselAdminData?.LastName,
            email: VesselAdminData?.Email,
            phone: "+" + CountryCodeValue + VesselAdminData?.CompanyPhoneNo,
            username:
              VesselAdminData?.FirstName?.toLowerCase() +
              "." +
              VesselAdminData?.LastName?.toLowerCase(),
            company_id: CompanyID,
            role_id: VessalAdminID,
            vessel_id: vesselName,
            is_super_admin: "false",
            password: passwordGenerator(),
          })
        );
      } else {
        toast.error("Please enter valid Email ID");
      }
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  useEffect(() => {
    if (!AddVesselAdminModel) {
      setVesselAdminData({
        FirstName: "",
        LastName: "",
        Email: "",
        CompanyPhoneNo: "",
      });
      setvesselName("");
    }
  }, [AddVesselAdminModel]);

  countries.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Modal
      open={AddVesselAdminModel}
      onClose={() => {
        dispatch(setIsOpenModelAddUserMaster(false));
        // setVesselAdminData({
        //   FirstName: "",
        //   LastName: "",
        //   Email: "",
        //   CompanyPhoneNo: "",
        // });
        // setvesselName("");
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Add New Vessel Admin
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() => {
                dispatch(setIsOpenModelAddUserMaster(false));
                // setVesselAdminData({
                //   FirstName: "",
                //   LastName: "",
                //   Email: "",
                //   CompanyPhoneNo: "",
                // });
                // setvesselName("");
              }}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="First Name"
                name="FirstName"
                value={VesselAdminData?.FirstName}
                onChange={handleChangeVesselAdminData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Last Name"
                name="LastName"
                value={VesselAdminData?.LastName}
                onChange={handleChangeVesselAdminData}
                sx={{
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Email"
                name="Email"
                value={VesselAdminData?.Email}
                onChange={handleChangeVesselAdminData}
                sx={{
                  width: "100%",
                  borderRadius: "50px",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <Autocomplete
                id="country-select-demo"
                sx={{ width: 300 }}
                options={countries}
                defaultValue={defaultCountry}
                autoHighlight
                onChange={(event, newValue) =>
                  handleChangeCountryCodeValue(newValue)
                }
                getOptionLabel={(option) => "+" + option.phone}
                filterOptions={(options, state) => {
                  // Filter based on option.label
                  return options.filter((option) =>
                    option.label
                      .toLowerCase()
                      .includes(state.inputValue.toLowerCase())
                  );
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                    key={option.label}
                  >
                    <img
                      loading="lazy"
                      width="20"
                      srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                      src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                      alt=""
                    />
                    {option.label}
                    {/* ({option.code}) +{option.phone} */}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                      borderRadius: "10px",
                      border: "none",
                      "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        border: "0px solid #F3F6F9",
                        borderRadius: "10px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                      "& .MuiAutocomplete-clearIndicator": {
                        display: "none",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    placeholder="Select Country"
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                  />
                )}
              />

              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Company Phone No"
                type="number"
                name="CompanyPhoneNo"
                value={VesselAdminData?.CompanyPhoneNo}
                onChange={handleChangeVesselAdminData}
                sx={{
                  width: "70%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .MuiInputBase-input": {
                    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button":
                      {
                        "-webkit-appearance": "none",
                        margin: 0,
                      },
                    "-moz-appearance": "textfield",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <Select
                id="outlined-basic"
                variant="outlined"
                displayEmpty
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={GreyDownArrow}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                value={vesselName}
                onChange={handleChangevesselName}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                MenuProps={{
                  sx: {
                    ".MuiList-root": {
                      maxHeight: "270px",
                      // width: "300px",
                      wordBreak: "break-word",
                    },
                    ".MuiMenuItem-root": {
                      overflowWrap: "break-word",
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Vessel Name
                </MenuItem>
                {vesselMasterData.map((item) => (
                  <MenuItem value={item?.id}>{item?.name}</MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Button
              // variant="contained"
              sx={{
                fontSize: "15px",
                border: "1px solid #26875C",
                fontWeight: 600,
                width: "8rem",
                // backgroundColor: "#26875C",
                padding: "10px 5px 10px 5px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#26875C",
                // ":hover": {
                //   backgroundColor: "#26875C",
                // },
              }}
              onClick={() => {
                dispatch(setIsOpenModelAddUserMaster(false));
                // setVesselAdminData({
                //   FirstName: "",
                //   LastName: "",
                //   Email: "",
                //   CompanyPhoneNo: "",
                // });
                // setvesselName("");
              }}
            >
              Cancel
            </Button>

            <LoadingButton
              onClick={handleSaveVesselAdmin}
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                width: "8rem",
                border: "1px solid #26875C",
                backgroundColor: "#26875C",
                padding: "10px 5px 10px 5px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#FFFFFF",
                ":hover": {
                  backgroundColor: "#26875C",
                },
              }}
              loading={isSaveButtonLoading}
            >
              Save
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddVesselAdminMasterModel;
